var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-1 px-1 blue--text text--darken-4",staticStyle:{"font-size":"0.755rem !important","font-weight":"500","letter-spacing":"0.08em","cursor":"default"},attrs:{"x-small":"","tile":"","depressed":"","color":"blue lighten-4"}},[_vm._v(" "+_vm._s(_vm.caption)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }